import $ from "jquery"; // Import jQuery
import { ProgressSpinner } from "primereact/progressspinner";
import React, { Children, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import Http from "../../../Common/Http";
import Select from "react-select";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [rmpm, setRmpm] = useState([]);
  const [list, setList] = useState([]);
  const { checkRequiredFields } = useRequiredFields();
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("");
  const [code, setCode] = useState([]);
  const [planningOptions, setPlanningOptions] = useState([]);
  const [setProducts, setSetProducts] = useState();
  const [item, setItem] = useState(null);
  const [itemList, setItemList] = useState([]);
  const [selection, setSelection] = useState(false);
  const [packagingStore, setPackagingStore] = useState(false);
  const [decalDepartment, setDecalDepartment] = useState(false);
  const [departments, setDepartments] = useState([
    {
      id: "",
      name: "Select a Department",
    },
    // {
    //   id: 14,
    //   name: "Decel Production",
    // },
    // {
    //   id: 8,
    //   name: "Selection",
    // },
    // {
    //   id: 11,
    //   name: "DFW",
    // },
    // {
    //   id: 17,
    //   name: "Packaging Production",
    // },
    {
      id: 16,
      name: "Mould",
    },
    // {
    //   id: 19,
    //   name: "Saggar",
    // },
  ]);

  // Modify the initial state of selectedDepartment
  const [selectedDepartment, setSelectedDepartment] = useState({
      id: 16,
      name: "Mould",
    });

  const [combinedList, setCombinedList] = useState([]); // New state for combined data
  console.log(combinedList, "combinedList");
  // Modify the handlePlanningChange function
  const handleDepartmentChange = (e) => {
    setDecalDepartment(false);
    const { name, value } = e.target;
    const selected = departments.find((dept) => dept.id === parseInt(value));
    setSelectedDepartment(selected);
    setInputs((prev) => ({
      ...prev,
      department_id: value,
    }));

    if (name == "department_id" && value == 8) {
      setDecalDepartment(false);
      setSelection(true);
      setPackagingStore(false);
    } else if (name == "department_id" && value == 14) {
      setDecalDepartment(true);
    } else if (name == "department_id" && value == 17) {
      setDecalDepartment(false);
      setSelection(true);
      setPackagingStore(true);
    } else {
      setDecalDepartment(false);
      setPackagingStore(false);
    }
  };

  console.log(selectedDepartment, "setSelectedDepartment");

  useEffect(() => {
    const fetchCodes = async () => {
      try {
        const res = await Http.get("/planning-image");
        const formattedData = res.data.map((item) => ({
          value: item.id, // Adjust according to your API response structure
          label: item.code, // Adjust according to your API response structure
        }));
        setCode(formattedData);
      } catch (error) {
        console.error("Error fetching codes:", error);
      }
    };
    fetchCodes();
  }, []);

  useEffect(() => {
    setLoading(true);
    $("body").addClass("collapse-menu");

    const fetchData = async () => {
      try {
        const resPlanning = await Http.get(
          "/production-work-order"
        );
        const planningData = resPlanning.data;
        console.log(planningData, "resPlanning");
        setPlanningOptions(planningData);
        if (planningData.length > 0) {
          // Automatically select the first planning and set in inputs
          const firstPlanning = planningData[0];
          setInputs((prevInputs) => ({
            ...prevInputs,
            planning_id: firstPlanning.id, // Assuming the ID field for planning
          }));

          // Load items for the first planning
          handlePlanningChange(firstPlanning.id);
        }

        const resRole = await Http.get("/staff-type-check");
        setRole(resRole.data);
        // const resRmpm = await Http.get("/product-list/all");
        // setRmpm(resRmpm.data);

        const resBatchNo = await Http.get(
          "/last-code-increment-by-one/requisition_arts/receipt_no/RD"
        );
        setInputs((values) => ({ ...values, ["receipt_no"]: resBatchNo.data }));

        getCurrentDateInput();
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const getCurrentDateInput = () => {
    const dateObj = new Date();

    // get the month in this format of 04, the same for months
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();

    const shortDate = `${year}-${month}-${day}`;

    setInputs((values) => ({ ...values, ["date"]: shortDate }));
    setInputs((values) => ({
      ...values,
      ["expected_production_date"]: shortDate,
    }));

    // Get the current time in the format "HH:mm"
    const hours = ("0" + dateObj.getHours()).slice(-2);
    const minutes = ("0" + dateObj.getMinutes()).slice(-2);

    const defaultTime = `${hours}:${minutes}`;

    setInputs((values) => ({ ...values, ["expected_time"]: defaultTime }));
  };
  console.log(packagingStore, "packagingStore");
  const addMoreList = async (id) => {
    try {
      const response = await Http.get(`/show-sample/${id}`);
      response;
      // console.log(combinedList[0]['data']['product'],'response.data')
      const { product: productData, totals: totalData } = response.data;
      console.log(combinedList, "combinedList.data");
      const productExists = combinedList.some(
        (product) =>
          product.data.production_work_order_item_id ===
          response.data.product.production_work_order_item_id
      );

      if (productExists) {
        Swal.fire({
          icon: "warning",
          title: "Product Already Added",
          text: "This product is already in the list",
        });
        return;
      }
      setCombinedList((prev) => [
        ...prev,
        { type: "product", data: productData, totals: totalData },
      ]);

      // Add product data to combinedList
      // setCombinedList((prev) => [
      //   ...prev,
      //   { type: "product", data: productData, totals: totalData },
      // ]);
    } catch (error) {
      console.error("Error fetching product:", error);
      Swal.fire("Error!", "Failed to add product.", "error");
    }
  };

  const addSetMoreList = async (id) => {
    try {
      const response = await Http.get(`/sets/${id}`);
      const setData = response.data; // Extract set data
      const productExists = combinedList.some(
        (product) => product.data.id === id
      );
      console.log(combinedList, "combinedList");
      if (productExists) {
        Swal.fire({
          icon: "warning",
          title: "Product Already Added",
          text: "This product is already in the list",
        });
        return;
      }
      console.log(response.data, "response.data.sets");
      // if (packagingStore === true) {
      //   setCombinedList((prev) => [...prev, { type: "set", data: setData }]);
      // }
      // Add set data to combinedList
      setCombinedList((prev) => [...prev, { type: "set", data: setData }]);
    } catch (error) {
      console.error("Error fetching set:", error);
      Swal.fire("Error!", "Failed to add set.", "error");
    }
  };

  console.log(itemList, "itemList");

  const removeGroup = (groupIndex) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will remove the entire work order.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Remove the entire group at the specified index
        const updatedList = list.filter((_, i) => i !== groupIndex);
        setList(updatedList);
        Swal.fire("Deleted!", "The group has been removed.", "success");
      }
    });
  };

  // Function to remove an item from the combinedList
  const removeList = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Update the combinedList state by filtering out the item at the specified index
        setCombinedList((prev) => prev.filter((_, i) => i !== index));
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      }
    });
  };

  // Add handleInputChange function to update individual items in the list
  const handleInputChange = (
    index,
    productIndex,
    field,
    value,
    remaining_value = null
  ) => {
    setCombinedList((prev) => {
      const newList = [...prev];

      /* artisan er 1st june er stock pawa porjonto eta temporary vabe off thakbe */
      
      if (remaining_value !== null && selectedDepartment.name === "Selection") {
        if (field === "qty_a" || field === "qty_b" || field === "qty_c") {
          if (value > remaining_value) {
            Swal.fire({
              title: "Error!",
              text: `${field} value must not be greater than ${remaining_value}.`,
              icon: "error"
            });
            value = 0;
          }
        }
      } 
          // */

      if (productIndex === null) {
        newList[index].data[field] = value;
      } else {
        const updatedItems = [...newList[index].data.items];
        updatedItems[productIndex][field] = value;
        newList[index].data.items = updatedItems;
      }

      return newList;
    });
  };

  const handlePlanningChange = async (planningId) => {
    if (!planningId) return;

    setList([]);
    setInputs((prevInputs) => ({
      ...prevInputs,
      planning_id: planningId, // Update planning_id in inputs
    }));

    try {
      // Fetch data based on selected planning ID
      const response = await Http.get(
        `/production-work-order/${planningId}`
      );
      console.log(response);
      setRmpm(response?.data.items);

      const setWiseProduct = await Http.get("/set-wise-products");
      setSetProducts(setWiseProduct.data);
      // if (role === "casting") {
      //   const casting =await response.data.items.filter(
      //     (item) => item.product.department_art_id == 3
      //   );
      //   setRmpm(casting);
      // }else if(role === "jigger") {
      //   const jigger =await response.data.items.filter(
      //     (item) =>item.product.department_art_id == 2
      //   );
      //   setRmpm(jigger);
      // }
      /*const productionTransferInfo = response.data.production_transfer_info;

      const planningItems = response.data.items.map((item) => {
        const productId = item.product_id;

        return {
          id: item.id,
          product_id: productId,
          product_name: item.product.name,
          shape: item.shape?.name,
          production_work_order: item.production_work_order?.receipt_no,
          company: item.production_work_order?.company?.name,
          product_code: item.product.code,
          planning_qty: item.qty,
          production_qty: 0,
          return_qty: 0,
          transfer_qty: "",
          total_production_qty:
            productionTransferInfo[productId]?.production_qty || 0, // Map production_qty
          total_transfer_qty:
            productionTransferInfo[productId]?.transfer_qty || 0, // Map transfer_qty
          weight: item.weight, // Example if qty is used as weight
          closing_balance: item.qty, // Example calculation; adjust if necessary
          remarks_delivery: "", // Set to empty or adjust if needed
        };
      });

      setList(planningItems);*/
    } catch (error) {
      console.error("Error fetching products for planning:", error);
      Swal.fire(
        "Error!",
        "Failed to fetch products for the selected planning.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // const formSubmit = () => {
  //   checkRequiredFields();
  //   const formData = {
  //     ...inputs,
  //     items: list,
  //     to_department_art_id: inputs.department_id
  //       ? parseInt(inputs.department_id)
  //       : null,
  //   };

  //   Http.post("/requisition-art", formData)
  //     .then((res) => {
  //       navigate("/department-requisition-jcg", {
  //         state: { message: res.data.message, type: "success" },
  //       });
  //     })
  //     .catch((e) => {
  //       setError(e.response?.data?.errors || {});
  //     });
  // };

  const formSubmit = () => {
    checkRequiredFields();
    console.log(combinedList, "combinedList");
    inputs.planning_id = null;
    // Collect items from combinedList
    // const items = combinedList
    //   .filter((item) => item.type === "product" || item.type === "set")
    //   .map((item) => {
    //     if (item.type === "set") {
    //       return {
    //           id: item?.data?.id,
    //           master_qty: item.data.master_qty,
    //           set_id: item.data.items[0]['set_id'],
    //           inner_qty: item.data.inner_qty,
    //           items: item.data.items.map((productItem) => ({
    //             product_id: productItem.product_id, // Adjust according to you structure
    //             id: productItem?.id,
    //             production_work_order_item_id:
    //               productItem?.production_work_order_item_id,
    //             product: productItem?.product,
    //             shape_id: productItem?.production_work_order_item?.shape_id,
    //             required_qty_a: productItem.qty_a || 0,
    //             required_qty_b: productItem.qty_b || 0,
    //             required_qty_c: productItem.qty_c || 0,
    //             required_qty_export: productItem.qty_export || 0,
    //             required_qty: productItem.qty || 0,
    //           }))
    //       };
    //     } else {
    //       return {
    //           product_id: item.data.product.id, // Adjust according to your data structure
    //           id: item?.data?.id,
    //           type: item.type,
    //           production_work_order_item_id:
    //             item?.data?.production_work_order_item_id,
    //           product: item?.data?.product,
    //           shape_id: item?.data?.shape_id,
    //           required_qty_a: item.data.qty_a || 0,
    //           required_qty_b: item.data.qty_b || 0,
    //           required_qty_c: item.data.qty_c || 0,
    //           required_qty_export: item.data.qty_export || 0,
    //           required_qty: item.data.required_qty || 0,
    //           set_id: item.data.items[0]['set_id'],
    //           master_qty: item.data.master_qty,
    //           inner_qty: item.data.inner_qty,
    //       };
    //     }
    //   });

    const items = combinedList
      .filter((item) => item.type === "product" || item.type === "set")
      .map((item) => {
        if (item.type === "set") {
          return {
            id: item?.data?.id,
            master_qty: item.data.master_qty,
            set_id: item.data.items[0]["set_id"],
            inner_qty: item.data.inner_qty,
            items: item.data.items.map((productItem) => ({
              product_id: productItem.product_id, // Adjust according to you structure
              id: productItem?.id,
              production_work_order_item_id:
                productItem?.production_work_order_item_id,
              product: productItem?.product,
              shape_id: productItem?.production_work_order_item?.shape_id,
              required_qty_a: 0,
              required_qty_b: 0,
              required_qty_c: 0,
              required_qty_export: 0,
              required_qty: 0,
            })),
          };
        } else {
          return {
            product_id: item.data.product.id, // Adjust according to your data structure
            id: null,
            type: item.type,
            production_work_order_item_id:
              item?.data?.production_work_order_item_id,
            product: item?.data?.product,
            shape_id: item?.data?.shape_id,
            required_qty_a: item.data.qty_a || 0,
            required_qty_b: item.data.qty_b || 0,
            required_qty_c: item.data.qty_c || 0,
            required_qty_export: item.data.qty_export || 0,
            required_qty: item.data.required_qty || 0,
            // set_id: item.data.items[0]['set_id'],
            master_qty: item.data.master_qty,
            inner_qty: item.data.inner_qty,
          };
        }
      });

    const formData = {
      ...inputs,
      items: items, // Ensure items is populated
      to_department_art_id: 16,
    };
    console.log(formData, "formData");
    // return false;
    Http.post("/requisition-art", formData)
      .then((res) => {
        navigate("/department-requisition-jcg", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch((e) => {
        setError(e.response?.data?.errors || {});
      });
  };

  console.log(item, "item");
  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger small">{error[fieldName]}</div>;
    }
    return null;
  };
  const cols = [
    // { field: "product.code", header: "Code" },
    { field: "product.name", header: "Item" },
    { field: "shape.name", header: "Shape" },
    // {
    //   field: (i) => (
    //     <>
    //       {i?.production_work_order?.company?.name}{" "}
    //       <b>#{i.production_work_order?.receipt_no}</b> || {i.product?.name}
    //     </>
    //   ),
    //   header: "Item",
    // },
    ...(role !== "jigger" && role !== "casting"
      ? [{ field: "shape.name", header: "Shape" }]
      : []),
    ...(role !== "jigger" && role !== "casting"
      ? [
          {
            field: "production_work_order.company.name",
            header: "Company",
          },
        ]
      : []),
    { field: "production_work_order.receipt_no", header: "Order" },
    { field: "production_work_order_item.qty", header: "Order Qty" },
    ...(role === "decoration_local" ||
    role === "decoration_export" ||
    role === "packing_local" ||
    role === "packing_export"
      ? [
          {
            field: "production_work_order_item.color.colour_name",
            header: "Glaze",
          },
          {
            field: "production_work_order_item.decoration.decoration_name",
            header: "Decoration Name",
          },
          {
            field: "production_work_order_item.decoration.code",
            header: "Decoration Code",
          },
        ]
      : []), // If the role does not match, return an empty array
  ];

  const setProductCols = [
    {
      field: (i) => <>{i.name}</>,
      header: "Item",
    },
  ];

  const actionTemplate = (item, deleteData) => {
    return (
      <td className="text-right">
        <button
          className="btn btn-success btn-sm"
          onClick={() => addMoreList(item.id)}
        >
          <i className="fa fa-plus"></i>
        </button>
      </td>
    );
  };

  const setActionTemplate = (item, deleteData) => {
    return (
      <td className="text-right">
        <button
          className="btn btn-success btn-sm"
          onClick={() => addSetMoreList(item.id)}
        >
          <i className="fa fa-plus"></i>
        </button>
      </td>
    );
  };

  // Modify the department options based on role
  const availableDepartments = () => {
    if (role === "packing_local" || role === "packing_export") {
      return [departments[0], departments[2], departments[3], departments[4]]; // Select options for packing roles
    } else if (role === "decoration_local" || role === "decoration_export") {
      return [departments[0], departments[1], departments[2]]; // Select options for decoration roles
    } else if (role === "sample") {
      return [departments[0], departments[1]]; // Select options for decoration roles
    }
    return [departments[0]]; // Default option
  };

  const selectHandleChange = (selectedOption, actionMeta, index) => {
    const { name } = actionMeta; // Get the name of the field
    const value = selectedOption.value; // Get the selected value

    // Create a copy of the current list state
    const inputInfo = [...list];

    // Update the specific field in the list
    inputInfo[index][name] = value;

    // Update the state with the new list
    setList(inputInfo);
  };

  const changeDepartment = () => {
    setTimeout(() => {
      setPackagingStore(false);
    }, 10);
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Department Requisition </h5>
        </div>
        <div className="am-pagebody row d-flex justify-content-evenly">
          <div className={"card pd-20 pd-sm-40 col-lg-8"}>
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Create Department Requisition To Mould
              {/* <strong>
                {role === "jigger" || role === "casting"
                  ? "Mould"
                  : role === "decoration_local" ||
                    role === "decoration_export" ||
                    role === "packing_local" ||
                    role === "packing_export"
                  ? selectedDepartment?.name || "Select a Department"
                  : role === "gk" ||
                    role === "bk" ||
                    role === "body" ||
                    role === "decoration_firing"
                  ? "Sagger"
                  : "Store"}
              </strong> */}
            </h6>
            <hr></hr>

            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date || ""}
                      onChange={handleChange}
                      placeholder="Input Date"
                      data-required
                    />

                    {displayError("date")}
                  </div>
                  <div className="col-lg">
                    <label>
                      Expected Time <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="time"
                      className="form-control"
                      name="expected_time"
                      value={inputs.expected_time || ""}
                      onChange={handleChange}
                      placeholder="Input Time"
                      data-required
                    />
                    {displayError("expected_time")}
                  </div>
                  <div className="col-lg">
                    <label>
                      Req. No. <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="receipt_no"
                      className="form-control"
                      name="receipt_no"
                      value={inputs.receipt_no || ""}
                      onChange={handleChange}
                      placeholder="Input Batch No"
                      data-required
                    />
                    {displayError("receipt_no")}
                  </div>
                </div>
                <div className="row mt-3">
                  {(role === "decoration_local" ||
                    role === "decoration_export" ||
                    role === "packing_local" ||
                    role === "packing_export" ||
                    role === "sample") && (
                    <div className="col-lg">
                      <>
                        <label>Department</label>
                        <select
                          className="form-control"
                          name="department_id"
                          value={selectedDepartment.id}
                          onChange={(e) => handleDepartmentChange(e)}
                          {...((role === "decoration_local" ||
                            role === "decoration_export" ||
                            role === "packing_local" ||
                            role === "packing_export" ||
                            role === "sample") && {
                            "data-required": true,
                          })}
                          disabled
                        >
                          {availableDepartments()?.map((department) => (
                            <option key={department?.id} value={department?.id}>
                              {department?.name}
                            </option>
                          ))}
                        </select>
                      </>
                    </div>
                  )}
                  {decalDepartment === true && role === "sample" && (
                    <>
                      <div className="col-lg">
                        <label>
                          Select Department{" "}
                          <i className="fa fa-star required"></i>{" "}
                        </label>
                        <select
                          className="form-select"
                          name="department_art_id"
                          onChange={handleChange}
                          data-required
                        >
                          <option value="">Select Department</option>
                          <option value="9">Decoration Local</option>
                          <option value="10">Decoration Export</option>
                        </select>
                      </div>
                    </>
                  )}

                  <div className="col-lg">
                    <label>Planning</label>
                    <select
                      className="form-control"
                      name="planning_id"
                      value={inputs.planning_id || ""} // Bind to inputs
                      onChange={(e) => handlePlanningChange(e.target.value)}
                    >
                      <option value="">Select Planning</option>
                      {planningOptions.map((planning) => (
                        <option
                          key={planning.id}
                          value={planning.id}
                          className={
                            planning?.production_work_order?.status ===
                            "on_test"
                              ? "text-danger"
                              : "1"
                          }
                        >
                          {planning.receipt_no}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="card-solid">
                    <div className="card-header with-border text-center">
                      <h5 className="card-title mb-0">Items in the list</h5>
                    </div>
                    <div className="card-body mt-3 p-0 pt-3">
                      <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Product</th>
                            <th>Shape</th>
                            <th>Order Qty</th>
                            <th>Company Order</th>

                            {(role !== "jigger" && role !== "casting") && (
                              <>
                                <th>Decoration</th>
                                <th>Glaze</th>
                              </>
                            )}
                            {(role === "decoration_local" ||
                              role === "decoration_export") && selectedDepartment.id === 14 && (
                              <th>Decoration Code</th>
                            )}
                            {selectedDepartment.name === "Packaging Production" && (
                              <>
                                <th>Set Qty</th>
                                <th>Inner Qty</th>
                                <th>Master Qty</th>
                              </>
                            )}
                            {selectedDepartment.name !== "Packaging Production" && (
                              <>
                                {(role === "packing_local" ||
                                  role === "decoration_local") && (
                                  <>
                                    {selectedDepartment.name !==
                                      "Packaging Production" && <th>Remain A</th>}
                                    <th>Qty A</th>
                                    {selectedDepartment.name !==
                                      "Packaging Production" && <th>Remain B</th>}
                                    <th>Qty B</th>
                                    {selectedDepartment.name !==
                                      "Packaging Production" && <th>Remain C</th>}
                                    <th>Qty C</th>
                                  </>
                                )}
                                {(role === "packing_export" ||
                                  role === "decoration_export") && (
                                  <>
                                    {selectedDepartment.name !==
                                      "Packaging Production" && (
                                      <th>Remain Export</th>
                                    )}
                                    <th>Qty Export</th>
                                  </>
                                )}
                                {(role === "jigger" ||
                                  role === "casting" ||
                                  role === "gk" ||
                                  role === "bk" ||
                                  role === "sagger" ||
                                  role === "body" ||
                                  role === "sample" ||
                                  role === "decoration_firing") && (
                                  <>
                                    {selectedDepartment.name ===
                                      "Selection" && <th>Selected</th>}
                                    <th>Qty</th>
                                  </>
                                )}
                              </>
                            )}
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {combinedList
                            .filter(
                              (item) =>
                                item.type !== "set" ||
                                selectedDepartment.name === "Packaging Production"
                            )
                            .map((item, index) => {
                              if (item.type === "set") {
                                // Render the set row
                                return (
                                  <React.Fragment key={index}>
                                    <tr>
                                      <td colSpan={8}>
                                        {item.data.code}{" "}
                                        <strong>
                                          <em>{item.data.name}</em>
                                        </strong>{" "}
                                        (
                                        {
                                          item.data.production_work_order
                                            .receipt_no
                                        }
                                        )
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control"
                                          placeholder="Inner"
                                          name="inner_qty"
                                          value={item.data.inner_qty || ""}
                                          onChange={(e) =>
                                            handleInputChange(
                                              index,
                                              null,
                                              "inner_qty",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control"
                                          placeholder="Master"
                                          name="master_qty"
                                          value={item.data.master_qty || ""}
                                          onChange={(e) =>
                                            handleInputChange(
                                              index,
                                              null,
                                              "master_qty",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>

                                      <td>
                                        <button
                                          className="btn btn-danger btn-sm"
                                          onClick={() => removeList(index)}
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </td>
                                    </tr>

                                    {item.data.items.map(
                                      (productItem, productIndex) => (
                                        <tr key={`${index}-${productIndex}`}>
                                          <td>{`${index + 1}.${
                                            productIndex + 1
                                          }`}</td>
                                          <td>
                                            <em>
                                              {productItem.product?.name ||
                                                "N/A"}
                                            </em>
                                          </td>
                                          <td>
                                            <em>
                                              {productItem
                                                .production_work_order_item
                                                ?.shape?.name || "N/A"}
                                            </em>
                                          </td>
                                          <td>
                                            <em>
                                              {item.data.production_work_order
                                                ?.receipt_no || "N/A"}
                                            </em>
                                          </td>
                                          
                                              <td>
                                                <em>
                                                  {productItem
                                                    .production_work_order_item
                                                    ?.decoration_name ||
                                                    "N/A"}{" "}
                                                  (
                                                  {
                                                    productItem
                                                      .production_work_order_item
                                                      ?.decoration?.code
                                                  }
                                                  ){" "}
                                                </em>
                                              </td>
                                              <td>
                                                <em>
                                                  {productItem
                                                    .production_work_order_item
                                                    ?.color?.colour_name ||
                                                    "N/A"}
                                                </em>
                                              </td>
                                           
                                          <td>
                                            <em>
                                              {productItem.product?.code ||
                                                "N/A"}
                                            </em>
                                          </td>
                                          <td>{productItem.qty || 0}</td>
                                        </tr>
                                      )
                                    )}

                                    <tr>
                                      <td colSpan={11}></td>
                                    </tr>
                                  </React.Fragment>
                                );
                              } else if (item.type === "product") {
                                // Render product items directly
                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.data.product?.name || "N/A"}</td>
                                    <td>{item.data.shape?.name || "N/A"}</td>
                                    <td>
                                      {item?.data?.production_work_order_item
                                        ?.qty || "N/A"}
                                    </td>
                                    <td>
                                      {item.data.production_work_order
                                        ?.receipt_no || "N/A"}
                                    </td>
                                    {/* <td>
                                      {item.data.production_work_order_item
                                        ?.decoration?.decoration_name || "N/A"}
                                    </td> */}
                                    {(role !== "jigger" && role !== "casting") && (
                                      <>
                                        <td>
                                          {item.data.production_work_order_item
                                            ?.decoration?.decoration_name || "N/A"}
                                        </td>
                                        <td>
                                          {item.data.production_work_order_item
                                            ?.color?.colour_name || "N/A"}
                                        </td>
                                      </>
                                    )}
                                    {/* <td>{item.data.product?.code || "N/A"}</td> */}
                                    {(role === "decoration_local" ||
                                      role === "decoration_export") && selectedDepartment.id === 14 && (
                                      <td>
                                        <Select
                                          options={code} // Use the state that holds the formatted code data
                                          onChange={(selectedOption) => {
                                            handleInputChange(
                                              index,
                                              null,
                                              "code_id",
                                              selectedOption.value
                                            ); // Pass the selected value correctly
                                          }}
                                          name="code_id"
                                          placeholder="Deco Code"
                                        />
                                      </td>
                                    )}
                                    {selectedDepartment.name ===
                                      "Packaging Production" && (
                                      <>
                                        <td>
                                          <em>N/A</em>
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  ""
                                                ))
                                            }
                                            className="form-control"
                                            value={item.data.inner_qty || ""}
                                            placeholder="inner qty"
                                            onChange={(e) =>
                                              handleInputChange(
                                                index,
                                                null,
                                                "inner_qty",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  ""
                                                ))
                                            }
                                            className="form-control"
                                            value={item.data.master_qty || ""}
                                            placeholder="master qty"
                                            onChange={(e) =>
                                              handleInputChange(
                                                index,
                                                null,
                                                "master_qty",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                      </>
                                    )}
                                    {selectedDepartment.name !==
                                      "Packaging Production" && (
                                      <>
                                        {(role === "packing_local" ||
                                          role === "decoration_local") && (
                                          <>
                                            {selectedDepartment.name !==
                                              "Packaging Production" && (
                                              <td>
                                                {" "}
                                                {
                                                  item.totals
                                                    .remaining_qty_a_class
                                                }{" "}
                                              </td>
                                            )}
                                            <td>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={item.data.qty_a || ""}
                                                placeholder="qty a"
                                                onInput={(e) =>
                                                  (e.target.value =
                                                    e.target.value.replace(
                                                      /\D/g,
                                                      ""
                                                    ))
                                                }
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    index,
                                                    null,
                                                    "qty_a",
                                                    e.target.value,
                                                    item.totals
                                                      .remaining_qty_a_class
                                                  )
                                                }
                                              />
                                            </td>

                                            {selectedDepartment.name !==
                                              "Packaging Production" && (
                                              <td>
                                                {" "}
                                                {
                                                  item.totals
                                                    .remaining_qty_b_class
                                                }{" "}
                                              </td>
                                            )}
                                            <td>
                                              <input
                                                type="text"
                                                onInput={(e) =>
                                                  (e.target.value =
                                                    e.target.value.replace(
                                                      /\D/g,
                                                      ""
                                                    ))
                                                }
                                                className="form-control"
                                                value={item.data.qty_b || ""}
                                                placeholder="qty b"
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    index,
                                                    null,
                                                    "qty_b",
                                                    e.target.value,
                                                    item.totals
                                                      .remaining_qty_b_class
                                                  )
                                                }
                                              />
                                            </td>
                                            {selectedDepartment.name !==
                                              "Packaging Production" && (
                                              <td>
                                                {" "}
                                                {
                                                  item.totals
                                                    .remaining_qty_c_class
                                                }{" "}
                                              </td>
                                            )}
                                            <td>
                                              <input
                                                type="text"
                                                onInput={(e) =>
                                                  (e.target.value =
                                                    e.target.value.replace(
                                                      /\D/g,
                                                      ""
                                                    ))
                                                }
                                                className="form-control"
                                                value={item.data.qty_c || ""}
                                                placeholder="qty c"
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    index,
                                                    null,
                                                    "qty_c",
                                                    e.target.value,
                                                    item.totals
                                                      .remaining_qty_c_class
                                                  )
                                                }
                                              />
                                            </td>
                                          </>
                                        )}

                                        {(role === "packing_export" ||
                                          role === "decoration_export") && (
                                          <>
                                            {selectedDepartment.name !==
                                              "Packaging Production" && (
                                              <td>
                                                {" "}
                                                {
                                                  item.totals
                                                    .remaining_qty_export
                                                }{" "}
                                              </td>
                                            )}
                                            <td>
                                              <input
                                                type="text"
                                                onInput={(e) =>
                                                  (e.target.value =
                                                    e.target.value.replace(
                                                      /\D/g,
                                                      ""
                                                    ))
                                                }
                                                className="form-control"
                                                placeholder="qty export"
                                                value={
                                                  item.data.qty_export || ""
                                                }
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    index,
                                                    null,
                                                    "qty_export",
                                                    e.target.value,
                                                    item.totals
                                                      .remaining_qty_export
                                                  )
                                                }
                                              />
                                            </td>
                                          </>
                                        )}
                                        {(role === "jigger" ||
                                          role === "casting" ||
                                          role === "gk" ||
                                          role === "bk" ||
                                          role === "sagger" ||
                                          role === "body" ||
                                          role === "sample" ||
                                          role === "decoration_firing") && (
                                          <>
                                            {selectedDepartment.name ===
                                              "Selection" && (
                                              <td>
                                                {" "}
                                                {item.totals.remaining_qty}{" "}
                                              </td>
                                            )}
                                            <td>
                                              <input
                                                type="text"
                                                onInput={(e) =>
                                                  (e.target.value =
                                                    e.target.value.replace(
                                                      /\D/g,
                                                      ""
                                                    ))
                                                }
                                                className="form-control"
                                                value={
                                                  item.data.required_qty || ""
                                                }
                                                placeholder="required qty"
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    index,
                                                    null,
                                                    "required_qty",
                                                    e.target.value,
                                                    item.totals.remaining_qty
                                                  )
                                                }
                                              />
                                            </td>
                                          </>
                                        )}
                                      </>
                                    )}
                                    <td>
                                      <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => removeList(index)}
                                      >
                                        <i className="fa fa-trash"></i>
                                      </button>
                                    </td>
                                  </tr>
                                );
                              }
                              return null;
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>

          {role === "packing_local" || role === "packing_export" ? (
            <div
              className="card pd-20 pd-sm-40 col-4"
              style={{ backgroundColor: "#ffffffc7" }}
            >
              <nav className="my-3 mx-auto">
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  {packagingStore && (
                    <>
                      <button
                        className="nav-link active"
                        id="nav-home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-home"
                        type="button"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                      >
                        Planning Products
                      </button>
                      {/* </>)}
                  {packagingStore && (
                    <> */}
                      <button
                        className="nav-link"
                        id="nav-profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-profile"
                        type="button"
                        role="tab"
                        aria-controls="nav-profile"
                        aria-selected="false"
                      >
                        Show Set Wise Products
                      </button>
                    </>
                  )}
                </div>
              </nav>

              <div className="tab-content" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                  tabIndex={0}
                >
                  <h6 className="card-body-title mg-sm-b-30 text-center">
                    Planning Products
                  </h6>
                  <hr></hr>

                  <ReactDataTable
                    cols={cols}
                    receiveData={rmpm}
                    isLoading={loading}
                    actionTemplate={actionTemplate}
                  />
                </div>

                {packagingStore && (
                  <>
                    <div
                      className="tab-pane fade"
                      id="nav-profile"
                      role="tabpanel"
                      aria-labelledby="nav-profile-tab"
                      tabIndex={0}
                    >
                      <h6 className="card-body-title mg-sm-b-30 text-center">
                        Show Set Wise Products
                      </h6>
                      <hr></hr>

                      <ReactDataTable
                        cols={setProductCols}
                        receiveData={setProducts}
                        isLoading={loading}
                        actionTemplate={setActionTemplate}
                        // deleteData={deleteData}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : (
            <div
              className="card pd-20 pd-sm-40 col-4"
              style={{ backgroundColor: "#ffffffc7" }}
            >
              <div
                className="tab-pane fade show active"
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
                tabIndex={0}
              >
                <h6 className="card-body-title mg-sm-b-30 text-center">
                  Planning Products
                </h6>
                <hr></hr>

                <ReactDataTable
                  cols={cols}
                  rowClassName={(rowData) => {
                    return rowData.production_work_order?.status === "on_test"
                      ? "bg-secondary text-white"
                      : "";
                  }}
                  receiveData={rmpm}
                  isLoading={loading}
                  actionTemplate={actionTemplate}
                  // deleteData={deleteData}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Create;
